import { useState } from "react";
import Appointments from "../pages/customers/Appointments";
import CustomersList from "../components/customers/CustomersList";
import AddCustomerModal from "../components/customers/AddCustomerModal";
export default function CustomersPage() {
  const [active, setActive] = useState<"customerslist" | "appointments" | "cashup">(
    "customerslist"
  );
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Save new customer (replace console.log with API call)
  const handleSaveCustomer = (data: any) => {
    console.log("New Customer:", data);
    // TODO: call API or mutation to save
  };

  return (
    <div className="">
      {/* 🔹Main Content */}
      {active === "customerslist" && <CustomersList />}
      {active === "appointments" && <Appointments />}
      {active !== "cashup" && active !== "appointments" && active !== "customerslist" && (
        <div className="flex items-center justify-center h-full">
          <p className="text-gray-500 text-lg">Coming Soon...</p>
        </div>
      )}

    </div>
  );
}
